import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FullUserFragmentDoc } from './FullUser.generated';
import type * as Types from './Types';

const defaultOptions = {} as const;
export type CloseMigrationAlertMutationVariables = Types.Exact<{
  close?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;

export type CloseMigrationAlertMutation = {
  updateMe?: {
    username?: string | null;
    fullname?: string | null;
    birthdate?: string | null;
    source?: Types.SourceOfFunds | null;
    createdAt: string;
    investedUSD: number;
    stripeId?: string | null;
    _id: string;
    email: string;
    admin: boolean;
    address?: { line1: string; line2: string; line3: string; zip: string; city: string; countryCode: string } | null;
    company?: { name: string; phone: string; countryCode: string } | null;
    kyc: {
      tier: number;
      identity: { status: Types.VerificationStatus };
      document: { status: Types.VerificationStatus };
      boardMeeting: { status: Types.VerificationStatus };
    };
    state: {
      termsAccepted?: boolean | null;
      closeMigrationAlert?: boolean | null;
      acceptedNewTerms?: boolean | null;
      bonusDPS?: boolean | null;
      eligibleToBonusDPS: boolean;
    };
    wallet?: { address: string; balance_wDPS?: string | null } | null;
    referral: {
      code: string;
      refereeCount: number;
      gains?: string | null;
      referrer?: { _id: string; fullname?: string | null; email: string; referral: { code: string } } | null;
      details: Array<{
        referred: { _id: string; fullname?: string | null; email: string; referral: { code: string } };
      }>;
    };
    twoFA: { otp: boolean };
    deposits: Array<{
      _id: string;
      amount: number;
      currency: Types.FiatCurrency;
      status: Types.DepositStatus;
      method: Types.DepositMethod;
      createdAt: string;
      wallet: string;
      user: { _id: string; email: string };
    }>;
    agreement: { id?: string | null; status: Types.AgreementStatus };
    transactions: Array<{
      _id: string;
      blockNumber: number;
      amount: string;
      rate: number;
      timestamp: string;
      transactionId: string;
      avaxAmount?: string | null;
      from: string;
    }>;
  } | null;
};

export const CloseMigrationAlertDocument = /*#__PURE__*/ gql`
  mutation CloseMigrationAlert($close: Boolean = true) {
    updateMe(state: { closeMigrationAlert: $close }) {
      ...FullUser
    }
  }
  ${FullUserFragmentDoc}
`;
export type CloseMigrationAlertMutationFn = Apollo.MutationFunction<
  CloseMigrationAlertMutation,
  CloseMigrationAlertMutationVariables
>;

/**
 * __useCloseMigrationAlertMutation__
 *
 * To run a mutation, you first call `useCloseMigrationAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseMigrationAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeMigrationAlertMutation, { data, loading, error }] = useCloseMigrationAlertMutation({
 *   variables: {
 *      close: // value for 'close'
 *   },
 * });
 */
export function useCloseMigrationAlertMutation(
  baseOptions?: Apollo.MutationHookOptions<CloseMigrationAlertMutation, CloseMigrationAlertMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CloseMigrationAlertMutation, CloseMigrationAlertMutationVariables>(
    CloseMigrationAlertDocument,
    options,
  );
}
export type CloseMigrationAlertMutationHookResult = ReturnType<typeof useCloseMigrationAlertMutation>;
export type CloseMigrationAlertMutationResult = Apollo.MutationResult<CloseMigrationAlertMutation>;
export type CloseMigrationAlertMutationOptions = Apollo.BaseMutationOptions<
  CloseMigrationAlertMutation,
  CloseMigrationAlertMutationVariables
>;
